import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useSelector } from "react-redux";
import MuiButton from "Components/MuiButton/MuiButton";
import DialogContent from "@material-ui/core/DialogContent";
import Translator from "Languages/Utility/Translator";
import {DialogActions} from "@material-ui/core";
import NewStuff from "./components/New/NewStuff";
import TblStuff from "./components/Tbl/TblStuff";
import { read } from "Helpers/LocalStorage";

function ManageStuff() {
  const { direction } = useTheme();
  const [openDialog, setOpenDialog] = useState(false);
  const { selectedBrandYaragh } = useSelector((state) => ({
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
  }));

  const handleDialog = () => setOpenDialog(!openDialog);

  return (
    <>
      <MuiButton
        color="secondary"
        title={<Translator id={"MahdoodeFaniProductManagement"}/>}
        onClick={handleDialog}
        fullwidthOnSm
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        fullWidth
        maxWidth="md"
      >
        <div className="dialogHeader">
          <p> {<Translator id={"MahdoodeFaniProductManagement"} />}</p>
        </div>
        <DialogContent id="content-dialog-manager">
          {
            read("ShisheRules").accessRegister &&
            <NewStuff selectedBrand={selectedBrandYaragh} />
          }
          <TblStuff selectedBrand={selectedBrandYaragh} />
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ManageStuff;